"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const eventemitter3_1 = __importDefault(require("eventemitter3"));
class BridgeInterface extends eventemitter3_1.default {
    performMouseDownAction(options) {
        return this.dispatch('mouseDownAnalogyActionWithOptions:', [options]);
    }
    ;
    performMouseUpAction(options) {
        return this.dispatch('mouseUpAnalogyActionWithOptions:', [options]);
    }
    ;
    singleClickAction(options) {
        return this.dispatch('singleClickActionWithOptions:', [options]);
    }
    ;
    doubleClickAction(options) {
        return this.dispatch('doubleClickActionWithOptions:', [options]);
    }
    ;
    longPressAction(options) {
        return this.dispatch('longPressActionWithOptions:', [options]);
    }
    ;
    startRotateAction(options) {
        return this.dispatch('didStartRotateAction:', [options]);
    }
    ;
    rotateAction(options) {
        return this.dispatch('rotateActionWithOptions:', [options]);
    }
    ;
    endRotateAction(options) {
        return this.dispatch('didEndRotateAction:', [options]);
    }
    ;
    startDragAction() {
        return this.dispatch('didStartDragAction');
    }
    ;
    dragAction(options) {
        return this.dispatch('dragActionWithOptions:', [options]);
    }
    ;
    endDragAction() {
        return this.dispatch('didEndDragAction');
    }
    ;
    startScaleAction() {
        return this.dispatch('didStartScaleAction');
    }
    ;
    scaleAction(options) {
        return this.dispatch('scaleActionWithOptions:', [options]);
    }
    ;
    endScaleAction() {
        return this.dispatch('didEndScaleAction');
    }
    ;
    startTwistAction(options) {
        return this.dispatch('didStartTwistAction:', [options]);
    }
    ;
    twistAction(options) {
        return this.dispatch('twistActionWithOptions:', [options]);
    }
    ;
    endTwistAction() {
        return this.dispatch('didEndTwistAction');
    }
    ;
    keyDownAction(options) {
        return this.dispatch('keyDownWithOptions:', [options]);
    }
    ;
    keyUpAction(options) {
        return this.dispatch('keyUpWithOptions:', [options]);
    }
    ;
    didPressHomeButton() {
        return this.dispatch('didPressHomeButton');
    }
    ;
    changeSystemState(options) {
        return this.dispatch('changeSystemState:', [options]);
    }
    ;
    resetAllSystems() {
        return this.dispatch('resetAllSystems');
    }
    ;
    selectCID(options) {
        return this.dispatch('selectCID:', [options]);
    }
    ;
    didEnterSearch() {
        return this.dispatch('didEnterSearch');
    }
    ;
    didExitSearch() {
        return this.dispatch('didExitSearch');
    }
    ;
    selectModelAndRegion(options) {
        return this.dispatch('selectModelAndRegion:', [options]);
    }
    ;
    selectModelsPanelTab(index) {
        return this.dispatch('selectModelsPanelTab:', [index]);
    }
    ;
    isolateAction(options) {
        return this.dispatch('isolateAction:', [options]);
    }
    ;
    exitIsolateMode() {
        return this.dispatch('exitIsolateMode');
    }
    ;
    hideAction() {
        return this.dispatch('hideAction');
    }
    ;
    fadeAction() {
        return this.dispatch('fadeAction');
    }
    ;
    hideOthersAction() {
        return this.dispatch('hideOthersAction');
    }
    ;
    fadeOthersAction() {
        return this.dispatch('fadeOthersAction');
    }
    ;
    infoBoxCloseAction() {
        return this.dispatch('infoBoxCloseAction');
    }
    ;
    enableMultipleSelection() {
        return this.dispatch('multipleSelectionAction');
    }
    ;
    disableMultipleSelection() {
        return this.dispatch('exitMultipleSelectionModeWithOptions:');
    }
    ;
    multipleSelectionUndoAction() {
        return this.dispatch('multipleSelectionUndoAction');
    }
    ;
    multipleSelectionRedoAction() {
        return this.dispatch('multipleSelectionRedoAction');
    }
    ;
    selectMultipleParts(options) {
        return this.dispatch('manageSelectionOfPartsForMultiSelectWithOptions:', [options]);
    }
    ;
    selectPartPlane(index) {
        return this.dispatch('thumbSelectionAction:', [index]);
    }
    ;
    toggleExplodeMode(options) {
        return this.dispatch('explodeMode:', [options]);
    }
    ;
    removePartFromSelection(options) {
        return this.dispatch('infoPanelListDeleteAction:', [options]);
    }
    ;
    toggleFadeMotionAction(options) {
        return this.dispatch('infoPanelFadeActionWithOptions:', [options]);
    }
    ;
    toggleFadeAllMotionActions(options) {
        return this.dispatch('infoPanelFadeMotionMuscles:', [options]);
    }
    ;
    motionAnimationPlayAction() {
        return this.dispatch('motionAnimationPlayAction');
    }
    ;
    motionAnimationPauseAction() {
        return this.dispatch('motionAnimationPauseAction');
    }
    ;
    motionAnimationMovementValueChangeAction(options) {
        return this.dispatch('motionAnimationMovementValueChangeAction:', [options]);
    }
    ;
    beatingHeartPlayAction() {
        return this.dispatch('beatingHeartPlayAction');
    }
    ;
    beatingHeartPauseAction() {
        return this.dispatch('beatingHeartPauseAction');
    }
    ;
    beatingHeartIncreaseBpmValueAction() {
        return this.dispatch('beatingHeartIncreaseBpmValueAction');
    }
    ;
    beatingHeartDecreaseBpmValueAction() {
        return this.dispatch('beatingHeartDecreaseBpmValueAction');
    }
    ;
    beatingHeartSliderValueChangeAction(options) {
        return this.dispatch('beatingHeartSliderValueChangeAction:', [options]);
    }
    ;
    toggleBeatingHeartAnimation() {
        return this.dispatch('toggleBeatingHeartAnimation');
    }
    ;
    setBeatingHeartEcgMode() {
        return this.dispatch('setBeatingHeartEcgMode');
    }
    ;
    setBeatingHeartSliderMode() {
        return this.dispatch('setBeatingHeartSliderMode');
    }
    ;
    selectInfoBoxListItem(options) {
        return this.dispatch('infoPanelListSelectionAction:', [options]);
    }
    ;
    exitModelAnimationMode() {
        return this.dispatch('stopModelAnimationAction');
    }
    ;
    exitCrossSectionsMode() {
        return this.dispatch('exitCrossSection');
    }
    ;
    deactivateInfoBoxTool(options) {
        return this.dispatch('infoPanelDidDeactivateTool:', [options]);
    }
    ;
    selectInfoBoxSupplyItem(options) {
        return this.dispatch('infoPanelSupplyTraceAction:', [options]);
    }
    ;
    playSelectedInfoBoxObjectAudio() {
        return this.dispatch('playSelectedObjectAudio');
    }
    ;
    toggleInfoBoxTab(type) {
        return this.dispatch('toggleInfoBoxTabWithType:', [type]);
    }
    ;
    selectTab(index) {
        return this.dispatch('selectTabAtIndex:', [index]);
    }
    ;
    createTab() {
        return this.dispatch('createTab');
    }
    ;
    closeTab(index) {
        return this.dispatch('closeTabAtIndex:', [index]);
    }
    ;
    selectBreadcrumbTrailItemAtIndex(index) {
        return this.dispatch('selectBreadcrumbTrailItemAtIndex:', [index]);
    }
    ;
    selectUserGroup(identifier) {
        return this.dispatch('selectUserGroup:', [identifier]);
    }
    ;
    createUserGroup(options) {
        return this.dispatch('createUserGroup:', [options]);
    }
    ;
    updateUserGroup(options) {
        return this.dispatch('updateUserGroup:', [options]);
    }
    ;
    removeUserGroup(identifier) {
        return this.dispatch('removeUserGroup:', [identifier]);
    }
    ;
    loadGroupMembers(options) {
        return this.dispatch('loadGroupMembers:', [options]);
    }
    ;
    searchUsers(searchValue) {
        return this.dispatch('searchUsers:', [searchValue]);
    }
    ;
    authenticate() {
        return this.dispatch('authenticate');
    }
    ;
    signUp() {
        return this.dispatch('signUp');
    }
    ;
    refresh() {
        return this.dispatch('refresh');
    }
    ;
    logout() {
        return this.dispatch('logout');
    }
    ;
    editAccount() {
        return this.dispatch('editAccount');
    }
    ;
    changePassword() {
        return this.dispatch('changePassword');
    }
    ;
    didPressLiveModeButton() {
        return this.dispatch('didPressLiveModeButton');
    }
    ;
    liveModeBackAction() {
        return this.dispatch('liveModeBackAction');
    }
    ;
    liveModeRefreshAction() {
        return this.dispatch('liveModeRefreshAction');
    }
    ;
    liveModeSliderAction(value) {
        return this.dispatch('liveModeSliderAction:', [value]);
    }
    ;
    liveModeExplodeAction() {
        return this.dispatch('liveModeExplodeAction');
    }
    ;
    liveModeDeselectObject() {
        return this.dispatch('liveModeDeselectObject');
    }
    ;
    startMultiuserARSession() {
        return this.dispatch('startMultiuserARSession');
    }
    ;
    endMultiuserARSession() {
        return this.dispatch('endMultiuserARSession');
    }
    ;
    joinMultiuserARSession(identifier) {
        return this.dispatch('joinMultiuserARSession:', [identifier]);
    }
    ;
    leaveMultiuserARSession() {
        return this.dispatch('leaveMultiuserARSession');
    }
    ;
    hostsListMultiuserARSession() {
        return this.dispatch('hostsListMultiuserARSession');
    }
    ;
    setUserDetailsARSession() {
        return this.dispatch('setUserDetailsARSession');
    }
    ;
    togglePreferenceBoolOption(options) {
        return this.dispatch('togglePreferenceBoolOption:', [options]);
    }
    ;
    updateInfoBoxTabsOrder(order) {
        return this.dispatch('updateInfoBoxTabsOrder:', [order]);
    }
    ;
    changeDiversityWithOptions(options) {
        return this.dispatch('changeDiversityWithOptions:', [options]);
    }
    ;
    setAppLanguage(language) {
        return this.dispatch('setAppLanguage:', [language]);
    }
    ;
    requestPushNotificationsPermissions() {
        return this.dispatch('requestPushNotificationsPermissions');
    }
    ;
    openSubscriptionManagementLink(productIdentifier) {
        return this.dispatch('openSubscriptionManagementLinkForProductIdentifier:', [productIdentifier]);
    }
    ;
    purchaseWithOptions(options) {
        return this.dispatch('purchaseWithOptions:', [options]);
    }
    ;
    restorePurchase() {
        return this.dispatch('restorePurchase');
    }
    ;
    promotedPurchase() {
        return this.dispatch('promotedPurchase');
    }
    ;
    generateFilterForContentType(options) {
        return this.dispatch('generateFilterForContentType:', [options]);
    }
    ;
    filterChangeSelectionForItem(options) {
        return this.dispatch('filterChangeSelectionForItem:', [options]);
    }
    ;
    onFilterApply() {
        return this.dispatch('onFilterApply');
    }
    ;
    onFilterReset() {
        return this.dispatch('onFilterReset');
    }
    ;
    closeRIE() {
        return this.dispatch('closeRIE');
    }
    ;
    openRIEById(identifier) {
        return this.dispatch('openRIEById:', [identifier]);
    }
    ;
    openRIEScreen(screen) {
        return this.dispatch('openRIEScreen:', [screen]);
    }
    ;
    restoreModelPositionInRIE() {
        return this.dispatch('restoreModelPositionInRIE');
    }
    ;
    selectRIEStructureWithOptions(options) {
        return this.dispatch('selectRIEStructureWithOptions:', [options]);
    }
    ;
    deselectRIEStructure() {
        return this.dispatch('deselectRIEStructure');
    }
    ;
    requestLibraryTabContent(options) {
        return this.dispatch('requestLibraryTabContent:', [options]);
    }
    ;
    requestResourceContent(options) {
        return this.dispatch('requestResourceContent:', [options]);
    }
    ;
    closeResourceContent(options) {
        return this.dispatch('closeResourceContent:', [options]);
    }
    ;
    requestSortByState(options) {
        return this.dispatch('requestSortByState:', [options]);
    }
    ;
    selectSortByOption(options) {
        return this.dispatch('selectSortByOption:', [options]);
    }
    ;
    setFavouriteResourceContent(options) {
        return this.dispatch('setFavouriteResourceContent:', [options]);
    }
    ;
    copyResourcesContent(options) {
        return this.dispatch('copyResourcesContent:', [options]);
    }
    ;
    createDeeplinkResourceContent(options) {
        return this.dispatch('createDeeplinkResourceContent:', [options]);
    }
    ;
    closePopupWithType(type) {
        return this.dispatch('closePopupWithType:', [type]);
    }
    ;
    historyUndoPressed() {
        return this.dispatch('historyUndoPressed');
    }
    ;
    historyRedoPressed() {
        return this.dispatch('historyRedoPressed');
    }
    ;
    historyUndoAllPressed() {
        return this.dispatch('historyUndoAllPressed');
    }
    ;
    toolkitClearAllTools() {
        return this.dispatch('toolkitDidClearAllTools');
    }
    ;
    historyClearPressed() {
        return this.dispatch('historyClearPressed');
    }
    ;
    historyResetScreenPressed() {
        return this.dispatch('historyResetScreenPressed');
    }
    ;
    historyRestoreItem(options) {
        return this.dispatch('historyRestoreItem:', [options]);
    }
    ;
    historyLockHistorySave() {
        return this.dispatch('historyLockHistorySave');
    }
    ;
    historyUnlockHistorySave() {
        return this.dispatch('historyUnlockHistorySave');
    }
    ;
    historyDidSelectTab() {
        return this.dispatch('historyDidSelectTab');
    }
    ;
    historySelectTab(index) {
        return this.dispatch('historySelectTab:', [index]);
    }
    ;
    saveUserSpecialtiesForFutureRegistration(items) {
        return this.dispatch('saveUserSpecialtiesForFutureRegistration:', [items]);
    }
    ;
    setModelOnboardingShown() {
        return this.dispatch('setModelOnboardingShown');
    }
    ;
    selectAppRegion(region) {
        return this.dispatch('setAppRegion:', [region]);
    }
    ;
    acceptPrivacyPolicy() {
        return this.dispatch('acceptPrivacyPolicy');
    }
    ;
    declinePrivacyPolicy() {
        return this.dispatch('declinePrivacyPolicy');
    }
    ;
    toolSelect(type) {
        return this.dispatch('toolSelect:', [type]);
    }
    ;
    toolUndo() {
        return this.dispatch('toolUndo');
    }
    ;
    toolRedo() {
        return this.dispatch('toolRedo');
    }
    ;
    toolClear() {
        return this.dispatch('toolClear');
    }
    ;
    toolUpdatePen(options) {
        return this.dispatch('toolUpdatePen:', [options]);
    }
    ;
    toolUpdateLabels(options) {
        return this.dispatch('toolUpdateLabels:', [options]);
    }
    ;
    toolUpdateCut(options) {
        return this.dispatch('toolUpdateCut:', [options]);
    }
    ;
    toolUpdateFracture(options) {
        return this.dispatch('toolUpdateFracture:', [options]);
    }
    ;
    toolUpdateGrowth(options) {
        return this.dispatch('toolUpdateGrowth:', [options]);
    }
    ;
    toolUpdateSpurs(options) {
        return this.dispatch('toolUpdateSpurs:', [options]);
    }
    ;
    toolUpdatePain(options) {
        return this.dispatch('toolUpdatePain:', [options]);
    }
    ;
    toolUpdateSketch(options) {
        return this.dispatch('toolUpdateSketch:', [options]);
    }
    ;
    cutModelByLine(options) {
        return this.dispatch('cutModelByLine:', [options]);
    }
    ;
    cutModelBetween(options) {
        return this.dispatch('cutModelBetween:', [options]);
    }
    ;
    cutModelByHole(options) {
        return this.dispatch('cutModelByHole:', [options]);
    }
    ;
    fractureModel(options) {
        return this.dispatch('fractureModel:', [options]);
    }
    ;
    performToolkitAction(options) {
        return this.dispatch('toolkitAction:', [options]);
    }
    ;
    toolkitOptionsAction(options) {
        return this.dispatch('toolkitOptionsAction:', [options]);
    }
    ;
    sendFractureShape(options) {
        return this.dispatch('sendFractureShape:', [options]);
    }
    ;
    toolkitHistoryAction(options) {
        return this.dispatch('toolkitAuxAction:', [options]);
    }
    ;
    addActionToHistory(options) {
        return this.dispatch('addHistoryStateWithOptions:', [options]);
    }
    ;
    selectLabel(options) {
        return this.dispatch('labelDidSelect:', [options]);
    }
    ;
    updateLabelPositions(options) {
        return this.dispatch('labelManagerDidPrepareToUpdateLabels:', [options]);
    }
    ;
    labelDelete(identifier) {
        return this.dispatch('labelDelete:', [identifier]);
    }
    ;
    labelUpdate(options) {
        return this.dispatch('labelUpdate:', [options]);
    }
    ;
    labelUpdatePosition(identifier) {
        return this.dispatch('labelUpdatePosition:', [identifier]);
    }
    ;
    labelSetGroupMode(isGroupMode) {
        return this.dispatch('labelSetGroupMode:', [isGroupMode]);
    }
    ;
    labelDeletePart(identifier) {
        return this.dispatch('labelDeletePart:', [identifier]);
    }
    ;
    labelSelectPart(identifier) {
        return this.dispatch('labelSelectPart:', [identifier]);
    }
    ;
    labelsDeselect() {
        return this.dispatch('deselectLabels');
    }
    ;
    labelDidCreate(options) {
        return this.dispatch('labelDidCreate:', [options]);
    }
    ;
    enterLabelGroupMode() {
        return this.dispatch('enterGroupLabelMode');
    }
    ;
    exitLabelGroupMode() {
        return this.dispatch('exitGroupLabelMode');
    }
    ;
    labelListDeleteAction(options) {
        return this.dispatch('labelListDeleteAction:', [options]);
    }
    ;
    pen2dUpdate(curves) {
        return this.dispatch('pen2dUpdate:', [curves]);
    }
    ;
    stickySelect(identifier) {
        return this.dispatch('stickySelect:', [identifier]);
    }
    ;
    stickyUnselect() {
        return this.dispatch('stickyUnselect');
    }
    ;
    stickyDelete(identifier) {
        return this.dispatch('stickyDelete:', [identifier]);
    }
    ;
    stickyUpdate(options) {
        return this.dispatch('stickyUpdate:', [options]);
    }
    ;
    textboxAdd() {
        return this.dispatch('textboxAdd');
    }
    ;
    sketchAdd() {
        return this.dispatch('sketchAdd');
    }
    ;
    videoPlayerOpen(options) {
        return this.dispatch('videoPlayerOpen:', [options]);
    }
    ;
    videoPlayerClose() {
        return this.dispatch('videoPlayerClose');
    }
    ;
    videoPlayerPlay() {
        return this.dispatch('videoPlayerPlay');
    }
    ;
    videoPlayerPause() {
        return this.dispatch('videoPlayerPause');
    }
    ;
    videoPlayerSetPlaybackPosition(options) {
        return this.dispatch('videoPlayerSetPlaybackPosition:', [options]);
    }
    ;
    videoPlayerUpdateSettings(options) {
        return this.dispatch('videoPlayerUpdateSettings:', [options]);
    }
    ;
    videoPlayerSetResource(options) {
        return this.dispatch('videoPlayerSetResource:', [options]);
    }
    ;
    closeSnackbarWithType(type) {
        return this.dispatch('closeSnackbarWithType:', [type]);
    }
    ;
    showSnackbarWithType(type) {
        return this.dispatch('showSnackbarWithType:', [type]);
    }
    ;
    openURL(options) {
        return this.dispatch('openUrlString:', [options]);
    }
    ;
    passInitialInfo(initialInfo) {
        return this.dispatch('passInitialInfo:', [initialInfo]);
    }
    ;
    openWebView(options) {
        return this.dispatch('openWebView:', [options]);
    }
    ;
    getValueByKey(key) {
        return this.dispatch('getValueByKey:', [key]);
    }
    ;
    putValueByKey(options) {
        return this.dispatch('putValueByKey:', [options]);
    }
    ;
    removeValueByKey(key) {
        return this.dispatch('removeValueByKey:', [key]);
    }
    ;
    toggleModelSex() {
        return this.dispatch('toggleModelSex');
    }
    ;
    downloadODRModels(options) {
        return this.dispatch('downloadODRModelsWithOptions:', [options]);
    }
    ;
    retryDownloadingODRModels(options) {
        return this.dispatch('retryDownloadingODRModelWithOptions:', [options]);
    }
    ;
    cancelODRModelDownload() {
        return this.dispatch('resetODRPendingModel');
    }
    ;
    requestRestoreControllerStateWithOptions(options) {
        return this.dispatch('requestRestoreControllerStateWithOptions', [options]);
    }
    ;
    requestCurrentStateOfController(options) {
        return this.dispatch('requestCurrentStateOfController', [options]);
    }
    ;
}
exports.default = BridgeInterface;
